import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BaseService} from '@nh/angular-tses';
import {Option, OptionProvider} from '../departure/departure-information/form/select/departure-select.component';
import {TemplateType} from '../departure/departure-information/form/select/template-type';

@Injectable({
  providedIn: 'root'
})
export class TemplateService extends BaseService implements OptionProvider<TemplateType> {
  private static readonly TEMPLATE_OPTIONS: Option<TemplateType>[] = [
    {
      value: TemplateType.DRAINAGE,
      displayName: 'Drainage'
    },
    {
      value: TemplateType.GEOTECHNICS,
      displayName: 'Geotechnics'
    },
    {
      value: TemplateType.LIGHTING,
      displayName: 'Lighting'
    },
    {
      value: TemplateType.PAVEMENT,
      displayName: 'Pavement'
    },
    {
      value: TemplateType.ROAD_LAYOUT,
      displayName: 'Road Layout'
    },
    {
      value: TemplateType.STRUCTURES,
      displayName: 'Structures'
    },
    {
      value: TemplateType.SUSTAINABILITY_AND_ENVIRONMENT,
      displayName: 'Sustainability & Environment'
    },
    {
      value: TemplateType.TECHNOLOGY,
      displayName: 'Technology'
    },
    {
      value: TemplateType.VEHICLE_RESTRAINT_SYSTEMS,
      displayName: 'Vehicle restraint systems'
    },
    {
      value: TemplateType.GENERAL,
      displayName: 'General'
    }
  ];

  // Deprecated array, but still needed to display historical departure templates
  private static readonly DEPRECATED_TEMPLATE_OPTIONS: Option<TemplateType>[] = [
    {
      value: TemplateType.GEOMETRIC,
      displayName: 'Geometric'
    },
    {
      value: TemplateType.SIGNALS_AND_VMS,
      displayName: 'Signals and VMS'
    },
    {
      value: TemplateType.NON_PRESCRIBED_TRAFFIC_SIGNS_AND_ROAD_STUDS,
      displayName: 'Non-prescribed traffic signs and road studs'
    }
  ];

  constructor(protected _snackbar: MatSnackBar) {
    super(_snackbar);
  }

  public static isValidTemplate(value: string): boolean {
    const templateType: TemplateType = TemplateType[value];
    const templateOption: Option<TemplateType> = TemplateService.TEMPLATE_OPTIONS.find(
      (option: Option<TemplateType>) => option.value === templateType
    );
    return !!templateOption;
  }

  public getOption(value: string): Promise<Option<TemplateType>> {
    const templateType: TemplateType = TemplateType[value];
    const templateOption: Option<TemplateType> =
      TemplateService.TEMPLATE_OPTIONS.find((option: Option<TemplateType>) => option.value === templateType) ||
      TemplateService.DEPRECATED_TEMPLATE_OPTIONS.find((option: Option<TemplateType>) => option.value === templateType);

    return Promise.resolve(templateOption);
  }

  public getOptions(): Promise<Option<TemplateType>[]> {
    return Promise.resolve(TemplateService.TEMPLATE_OPTIONS);
  }
}
